import { useNavigate } from "react-router-dom";
import logo from "best-barista-logo.png";

export const Footer = () => {
  const d = new Date();
  let year = d.getFullYear();
  const navigate = useNavigate();
  return (
    <footer className="invisible mt-auto bg-white p-4 shadow dark:bg-gray-900 md:visible md:px-6 md:py-8 print:hidden">
      <div className=" sm:flex sm:items-center sm:justify-between ">
        <a href="/" className="mb-4 sm:mb-0">
          <img
            src={logo}
            className="-mt-2 mb-2 mr-3 h-9 w-auto lg:h-auto lg:w-32"
            alt="BestBarista Logo"
          />
        </a>
      </div>
      <hr className="my-6 border-gray-200 dark:border-gray-700 sm:mx-auto lg:my-8" />
    </footer>
  );
};
